import * as React from "react";
import "./ReviewScreen.css";
import { Caregiver } from "../messages/Caregiver";
import { MobileStickyHeader } from "./widgets/MobileStickyHeader";
import { CaregiverCertification } from "src/messages";

interface ReviewScreenProps {
    header: string | null;
    body: string | null;
    caregiver: Caregiver;
    close: () => void;
}

interface ReviewScreenState {
    confirmText: string;
}

export class ReviewScreen extends React.Component<ReviewScreenProps, ReviewScreenState> {
    constructor(props: ReviewScreenProps) {
        super(props);

        this.state = {
            confirmText: "I confirm that I reviewed the application and agree!"
        };
    }

    handleConfirmClick() {
        this.setState({ confirmText: "Success, All Done! Please contact your agency." });
        setTimeout(function () {
            location.reload();
        }, 3000);
    }

    render() {
        return (
            <div className={"ReviewScreen__wrapper"}>
                <MobileStickyHeader title="Review" close={this.props.close} />
                <div className={"ReviewScreen_root"}>
                    {this.props.header === null ? null :
                        <h1 className={"ReviewScreen_header"}>
                            {this.props.header}
                        </h1>
                    }
                    <h3 className={"ReviewScreen_header"}>
                        Following your application, these are the files that you should physically provide to the HR
                        department in order to complete the registration process.
                    </h3>
                    <h4 className={"ReviewScreen_subHeader"}>
                        {this.props.caregiver.email !== null ? `This list will be sent to your email at ${this.props.caregiver.email} and ` : null}until you will present all theses files to the agency you will not be able to get cases from the agency
                    </h4>
                    {this.props.body === null ? null :
                        <ul className={"ReviewScreen_body"}>
                            {
                                this.props.body.split("\n").map((part) => {
                                    const caregiverCertificationRegex = new RegExp("{certification_type}", "g");
                                    if (part.trim().length === 0) {
                                        return <br/>;
                                    }
                                    return (
                                        <li key={part}>
                                            {part.replace(caregiverCertificationRegex, CaregiverCertification.unwrap(this.props.caregiver.certifications[0]))}
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    }
                    <input
                        type={"button"}
                        className={"btn btn-primary btn-block btn-lg ReviewScreen__button"}
                        value={this.state.confirmText}
                        onClick={() => this.handleConfirmClick()}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ReviewScreen.tsx